export default __webpack_public_path__ + "static/media/project_bullground_4.3118dd94.png";